import apiClient from "../../../utilities/apiClient";

export const change_Password = (payload) => {
  return apiClient.post(`${apiClient.Urls.change_password}`, payload, true);
};
